import _slicedToArray from "C:\\xampp\\htdocs\\beezer\\Platform\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
// TODO: Remove this ignore comment.
// eslint-disable-next-line no-mixed-operators
var toHex = function toHex(red, green, blue, alpha) {
  return (blue | green << 8 | red << 16 | 1 << 24).toString(16).slice(1) + alpha;
};
export default function rgbHex(red, green, blue, alpha) {
  var isPercent = (red + (alpha || '')).toString().includes('%');
  if (typeof red === 'string' && !green) {
    // Single string parameter.
    var parsed = parseCssRgbString(red);
    if (!parsed) {
      throw new TypeError('Invalid or unsupported color format.');
    }
    isPercent = false;
    var _parsed = _slicedToArray(parsed, 4);
    red = _parsed[0];
    green = _parsed[1];
    blue = _parsed[2];
    alpha = _parsed[3];
  } else if (alpha !== undefined) {
    alpha = Number.parseFloat(alpha);
  }
  if (typeof red !== 'number' || typeof green !== 'number' || typeof blue !== 'number' || red > 255 || green > 255 || blue > 255) {
    throw new TypeError('Expected three numbers below 256');
  }
  if (typeof alpha === 'number') {
    if (!isPercent && alpha >= 0 && alpha <= 1) {
      alpha = Math.round(255 * alpha);
    } else if (isPercent && alpha >= 0 && alpha <= 100) {
      alpha = Math.round(255 * alpha / 100);
    } else {
      throw new TypeError("Expected alpha value (".concat(alpha, ") as a fraction or percentage"));
    }
    alpha = (alpha | 1 << 8).toString(16).slice(1); // eslint-disable-line no-mixed-operators
  } else {
    alpha = '';
  }
  return toHex(red, green, blue, alpha);
}
var parseCssRgbString = function parseCssRgbString(input) {
  var parts = input.replace(/rgba?\(([^)]+)\)/, '$1').split(/[,\s/]+/).filter(Boolean);
  if (parts.length < 3) {
    return;
  }
  var parseValue = function parseValue(value, max) {
    value = value.trim();
    if (value.endsWith('%')) {
      return Math.min(Number.parseFloat(value) * max / 100, max);
    }
    return Math.min(Number.parseFloat(value), max);
  };
  var red = parseValue(parts[0], 255);
  var green = parseValue(parts[1], 255);
  var blue = parseValue(parts[2], 255);
  var alpha;
  if (parts.length === 4) {
    alpha = parseValue(parts[3], 1);
  }
  return [red, green, blue, alpha];
};